const imports = [
    { selector: "#report_doc", module: () => require('../doc/doc_report.js') },
    { selector: "#report_doc_delete", module: () => require('../doc/doc_report_delete.js') },
    { selector: "#report_doc_xls", module: () => require('../doc/doc_report_xls.js') },
];

imports.forEach(item => {
    if ($(item.selector).length > 0) {
        item.module();
    }
});
